import { createSlice } from '@reduxjs/toolkit';
import { nanoid } from 'nanoid';

const initialState = [];

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    set(_, action) {
      return action.payload;
    },
    add: {
      reducer(state, action) {
        return [
          ...state,
          action.payload,
        ];
      },
      prepare: (payload) => {
        const id = nanoid();

        return { payload: { id, delayTime: 3000, ...payload } };
      },
    },
    remove(state, action) {
      return state.filter(({ id }) => id !== action.payload.id);
    },
    reset() {
      return initialState;
    },
  },
});

export const notifications = notificationsSlice.actions;
export default notificationsSlice.reducer;
